import { FC } from "react";
import { LoveLineTemplate1 } from "./LoveLineTemplate1/LoveLineTemplate1";
import { LoveLineTemplate2 } from "./LoveLineTemplate2/LoveLineTemplate2";
import { LoveLineGallery } from "./LoveLineGallery/LoveLineGallery";

export const LoveLine: FC = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
          <div className="timeline">
            <div
              className="year"
              data-animation-direction="from-top"
              data-animation-delay="250"
            >
              <span className="neela-style" style={{ fontWeight: 300 }}>
                <span className="h-lines"></span>
                <span className="v-lines"></span>2021
              </span>
            </div>

            <LoveLineTemplate1 />

            <LoveLineGallery />

            <div
              className="year"
              data-animation-direction="from-top"
              data-animation-delay="250"
            >
              <span className="neela-style" style={{ fontWeight: 300 }}>
                <span className="h-lines"></span>
                <span className="v-lines"></span>2024
              </span>
            </div>

            <LoveLineTemplate2 />
          </div>

          <div className="timeline_footer">
            <i
              className="icon-diamond-ring"
              data-animation-direction="from-top"
              data-animation-delay="250"
            ></i>
            <div
              className="punchline"
              data-animation-direction="from-bottom"
              data-animation-delay="250"
            >
              <small>This is where our</small>
              <span style={{ fontWeight: 100 }}>
                forever
                <br />
                begins!
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
